import React, {createPortal, useEffect} from "preact/compat";
import constants from "../constants";
import store from "../store";
import * as actions from '../actions';
import util from "../util";

export interface CreateQRDesignModalProps {
  open: boolean;
  onClose: () => void;
}

export default function CreateQRDesignModal({open, onClose}: CreateQRDesignModalProps) {
  useEffect(() => {
  }, []);

  function viewQRDesigns(family: string) {
    onClose();
    if (store.getState().isMobileVersion) {
        store.dispatch(actions.setIsMobileAside(true));
    }
    store.dispatch(actions.setView('templates'));
    store.dispatch(actions.setTemplateView('group'));
    store.dispatch(actions.setSelectedFamily(family));
    store.dispatch(actions.setSelectedCollection(''));
    store.dispatch(actions.setIsQRDesignMode(true));
  }

  return open ? createPortal(<div>
    <div className="modal-back" onClick={onClose}/>
    <div className="modal qr-design" onClick={e => e.stopPropagation()}>
        <a className="close" onClick={onClose}>
            <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-close"}/>
            </svg>
        </a>

        <header>
            <h2>Choose how to display your code:</h2>
        </header>

        <div className="content">
            <div class="design-card" onClick={() => viewQRDesigns('Table Tent')}>
                <img src={constants.appPrefix + '/image/QRDesign-TableTents.png'} class="img"></img>
                <div class="flag">
                    <img src={constants.appPrefix + '/image/qr-flag.svg'} class="img"></img>
                    <div>10 for $23.95</div>
                </div>
                <p>Table Tent</p>
            </div>
            <div class="design-card" onClick={() => viewQRDesigns('Sticker')}>
                <img src={constants.appPrefix + '/image/QRDesign-Stickers.png'} class="img"></img>
                <div class="flag">
                    <img src={constants.appPrefix + '/image/qr-flag.svg'} class="img"></img>
                    <div>250 for $209.95</div>
                </div>
                <p>Sticker</p>
            </div>
            <div class="design-card" onClick={() => viewQRDesigns('Flyer')}>
                <img src={constants.appPrefix + '/image/QRDesign-Flyers.png'} class="img"></img>
                <div class="flag">
                    <img src={constants.appPrefix + '/image/qr-flag.svg'} class="img"></img>
                    <div>10 for $13.95</div>
                </div>
                <p>Flyer</p>
            </div>
        </div>
    </div>
  </div>, document.getElementById('modals')!) : null;
}
